import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, omit } from 'lodash-es';
import { connect } from 'react-redux';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Container from 'reactstrap/lib/Container';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getModelState } from 'client/data/luckdragon/model';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, CmsModel, bindToContent } from 'client/data/models/cms';
import { getPageLinksPath, LinkWidgetsModel } from 'client/data/models/link-widgets';
import { buildPubStateModelYearPath, VehicleModel } from 'client/data/models/vehicle';
import { HomeModulesModel } from 'client/data/models/home-modules';
import { parseContent } from 'client/data/cms/content';
import { getMeta, getSeoImage } from 'site-modules/shared/utils/seo-helper';
import { getFAQSchema } from 'client/seo/schemas/faq';
import { getQAEntriesFromContent } from 'client/site-modules/shared/utils/faq';
import { TrackingHandler } from 'client/tracking/handler';
import {
  TrackingMap,
  MMZ_TRACKING_IDS,
  TOP_LINKS_TRACKING_MAP,
} from 'client/tracking/maps/used-cars-landing/used-cars-landing';
import { HomepageAdExtensionMap } from 'client/tracking/maps/common/homepage-ad-extension';
import { MoreInfoSection } from 'site-modules/used-cars-landing/components/more-info-section/more-info-section';
import { MostPopularModule } from 'site-modules/used-cars-landing/components/most-popular-module/most-popular-module';
import { TopLinksSection } from 'site-modules/shared/components/top-links-section/top-links-section';
import { ArticlesModule } from 'site-modules/shared/components/articles-module/articles-module';
import { HelpfulTipsModule } from 'site-modules/shared/components/helpful-tips-module/helpful-tips-module';
import { HighlyRatedModule } from 'site-modules/used-cars-landing/components/highly-rated-module/highly-rated-module';
import { TopMakesSection } from 'site-modules/shared/components/top-makes-section/top-makes-section';
import { EdmundsDefaultDecorator } from 'site-modules/shared/pages/decorators/edmunds-default';
import { PageLinksWidget } from 'site-modules/shared/components/page-links-widget/page-links-widget';
import { BuyOnlineSection } from 'site-modules/shared/components/buy-online-section/buy-online-section';
import { BODY_TYPE, ENGINE_TYPE } from 'site-modules/shared/constants/allowed-seo-srp-request-params';
import { SearchByModuleContent } from 'site-modules/shared/components/search-by-module/search-by-module-content';
import { TrackCarValueModule } from 'client/site-modules/shared/components/track-car-value/track-car-value-module';
import { HomeMarquee } from 'site-modules/shared/components/upper-funnel/home-marquee/home-marquee';
import { MrectNative } from 'site-modules/shared/components/native-ad/mrect/mrect-native';
import { NewUsedLandingHero } from 'site-modules/shared/components/new-used-landing-hero/new-used-landing-hero';
import { CpoModule } from 'site-modules/shared/components/cpo-module/cpo-module';
import { PUB_STATES } from 'client/constants/pub-states';
import './index.scss';

const PAGE_NAME = 'used_cars_index';
const PAGE_CATEGORY = 'used_cars_index';
const DEFAULT_H1_TITLE = 'Used Cars for Sale Nationwide';
const DEFAULT_SUBTITLE = 'Find great deals on the best used cars for sale.';
const DEFAULT_MOST_POPULAR_TITLE = 'Shop great deals on the most popular used cars for sale';
const DEFAULT_TOP_LINKS_TITLE = 'Used car buying tools';
export const USED_LANDING_CONTENT_FILE_PATH = 'used-cars-for-sale/index';

export class UsedCarsForSalePageUI extends Component {
  static propTypes = {
    content: CmsEntities.Content,
    isMobile: PropTypes.bool,
    location: PropTypes.shape({}),
  };

  static defaultProps = {
    content: null,
    isMobile: false,
    location: {},
  };

  constructor(props) {
    super(props);

    this.state = { params: {} };
  }

  componentDidMount() {
    TrackingHandler.useMap({ ...TrackingMap, ...HomepageAdExtensionMap });
  }

  /**
   * Update params which will use to configure the right link to the BOL SRP
   * @param {Object} params
   */
  updateParams = params => {
    let currentParams = this.state.params;
    const key = Object.keys(params)[0];
    if ([ENGINE_TYPE, BODY_TYPE].includes(key)) {
      currentParams = omit(this.state.params, [ENGINE_TYPE, BODY_TYPE]);
    }
    this.setState({ params: { ...currentParams, ...params } });
  };

  render() {
    const { content, isMobile, location } = this.props;
    const { params } = this.state;

    if (!content) {
      return null;
    }

    const h1Title = get(content, 'title', DEFAULT_H1_TITLE);
    const pageSubTitle = get(content, 'subtitle', DEFAULT_SUBTITLE);
    const breadcrumbs = content.child('breadcrumb');
    const mostPopular = get(content.child('most-popular'), 'childEntries', []);
    const mostPopularTitle = get(content.child('most-popular'), 'title', DEFAULT_MOST_POPULAR_TITLE);
    const helpfulArticlesContent = content.child('article-grid');
    const helpfulTipsContent = content.child('article-list');
    const topLinks = content.child('top-links');
    const topLinksTitle = get(topLinks, 'title', DEFAULT_TOP_LINKS_TITLE);
    const highlyRated = content.child('highly-rated');
    const topMakes = content.child('top-makes');
    const moreInfoContent = content.child('article');
    const faqContent = content.child('faq');
    const cpoContent = content.child('cpo-module');

    return (
      <main id="main-content" tabIndex={-1} className="used-cars-for-sale-page">
        <NewUsedLandingHero
          title={h1Title}
          subTitle={pageSubTitle}
          breadcrumbsData={breadcrumbs.links()}
          trackingParent="edm-used-cars-index-hero"
        >
          <SearchByModuleContent
            className="bg-white overlap-module border-0 p-1_5"
            tabsContainerClassName="mb-1_25"
            location={location}
            isMobile={isMobile}
            trackingMap={MMZ_TRACKING_IDS}
            isUsed
            onUpdateParams={this.updateParams}
            showRadioButtons
          />
        </NewUsedLandingHero>
        <Container>
          <div data-tracking-parent="car_buying_tools">
            <TopLinksSection content={topLinks} title={topLinksTitle} tracking={TOP_LINKS_TRACKING_MAP} />
          </div>
          <hr className="mt-1_5 mb-2" />
          <Row>
            <Col xs={12} lg={9} xl={8}>
              <BuyOnlineSection params={params} isMobile={isMobile} />
            </Col>
          </Row>

          <hr className="mt-1_5 mb-2" />
          <Row>
            <Col xs={12} lg={10}>
              <TrackCarValueModule
                btnColor="blue-50"
                ctaText="See your car's value"
                isAppraisalValueUrl
                creativeId="appraise_sell_vehicle_entry"
              />
            </Col>
          </Row>
          <hr className="mt-1_5 mb-2" />
          <Row>
            <Col xs={12} lg={10}>
              <CpoModule content={cpoContent} />
            </Col>
          </Row>
          <hr className="mt-1_5 mb-2" />
          <MostPopularModule popularSubmodels={mostPopular} title={mostPopularTitle} />
          <hr className="mt-1_5 mb-2" />
          <Row>
            <Col xs={12} lg={8}>
              <HomeMarquee />
              <hr className="mt-1_5 mb-2" />
              <ArticlesModule content={helpfulArticlesContent} isLazyImages />
            </Col>
            <Col xs={12} lg={4}>
              <HelpfulTipsModule content={helpfulTipsContent} className="ps-lg-2 mt-0 mt-md-1_5 mt-lg-0" />
              <MrectNative
                position={'1'}
                wrapperClass="mt-2"
                refreshable={false}
                renderWhenViewable
                verticalOffset="100%"
                useMinHeight
              />
            </Col>
          </Row>
          <hr className="mt-1_5 mb-2" />
          <Row>
            <Col xs={12} lg={8}>
              <HighlyRatedModule highlyRatedContent={highlyRated} />
              <hr className="mt-1_5 mb-2 hidden-lg-up" />
            </Col>
            <Col xs={12} lg={4}>
              <TopMakesSection topMakes={topMakes} className="ps-lg-0_5" />
            </Col>
          </Row>
          <hr className="mt-1_5 mb-2" />
          <Row>
            <Col xs={12} lg={8}>
              <MoreInfoSection content={moreInfoContent} faqContent={faqContent} pathname={location.pathname} />
              {isMobile && (
                <MrectNative
                  mobileOnly
                  position={'2'}
                  wrapperClass="my-1"
                  refreshable={false}
                  renderWhenViewable
                  verticalOffset="100%"
                  useMinHeight
                />
              )}
            </Col>
            {!isMobile && (
              <Col xs={12} lg={4}>
                <MrectNative
                  wiredOnly
                  position={'2'}
                  wrapperClass="mb-md-2 mt-lg-2"
                  refreshable={false}
                  renderWhenViewable
                  verticalOffset="100%"
                  useMinHeight
                />
              </Col>
            )}
          </Row>
          <hr className="mt-1_5 mb-2" />
          <PageLinksWidget divideSections={false} title="Related information" />
        </Container>
      </main>
    );
  }
}

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const stateToPropsConfig = {
  content: bindToContent(USED_LANDING_CONTENT_FILE_PATH),
};

export const UsedCarsForSalePage = connect(mapStateToProps)(connectToModel(UsedCarsForSalePageUI, stateToPropsConfig));

export const pageDefinitionConfiguration = {
  name: PAGE_NAME,
  category: PAGE_CATEGORY,
  seo: (state, props) => {
    const modelState = getModelState(state);
    const usedLandingContent = modelState.get(`content["${USED_LANDING_CONTENT_FILE_PATH}"]`, CmsModel);
    const content = parseContent(usedLandingContent);
    const faqContent = content.child('faq');
    return {
      ...getMeta(content),
      jsonld: [
        getFAQSchema({
          entries: getQAEntriesFromContent(faqContent),
          image: getSeoImage(content),
          pathname: get(props, 'location.pathname', ''),
          generateLearnMoreLinks: true,
        }),
      ],
    };
  },
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${USED_LANDING_CONTENT_FILE_PATH}"]`, CmsModel);
    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);
    preloader.resolve('homeHeroContent', HomeModulesModel);
    preloader.resolve('makesList', VehicleModel);
    preloader.resolve(buildPubStateModelYearPath([PUB_STATES.USED, PUB_STATES.NEW_USED]), VehicleModel);

    // preload for the globalnav 'Try "Accord"' search box
    preloader.resolve('content["/global/global-nav-content"]', CmsModel);

    return preloader.load();
  },
  component: UsedCarsForSalePage,
  decorator: EdmundsDefaultDecorator,
};

export default pageDefinition(pageDefinitionConfiguration);
